import { render } from "./previewVideo.vue?vue&type=template&id=bd2efe28&scoped=true&ts=true"
import script from "./previewVideo.vue?vue&type=script&lang=ts"
export * from "./previewVideo.vue?vue&type=script&lang=ts"

import "./previewVideo.vue?vue&type=style&index=0&id=bd2efe28&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd2efe28"]])

export default __exports__